"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/nl");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternatieve tekst:"
  },
  announcement_list_da155734: {
    message: "Lijst met aankondiging"
  },
  announcements_a4b8ed4a: {
    message: "Aankondigingen"
  },
  assignments_1e02582c: {
    message: "Opdrachten"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Achtergrondkleur, er op drukken om een optie te selecteren"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Uploaden van bestand annuleren"
  },
  cancel_image_upload_2c771950: {
    message: "Uploaden van afbeelding annuleren"
  },
  cc_attribution_f6de631f: {
    message: "CC-bijdrage"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC-bijdrage, geen afgeleiden"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC-bijdrage, niet-commercieel"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC-bijdrage, niet-commercieel, geen afgeleiden"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC-bijdrage, niet-commercieel, gelijke delen"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC-bijdrage, gelijke delen"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Controleer of de afbeelding decoratief genoeg is"
  },
  choose_usage_rights_33683854: {
    message: "Gebruiksrechten kiezen..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Op een bestand klikken om een link voor het downloaden van dat bestand in te voegen."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Klikken op een afbeelding om deze in te sluiten op de pagina."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Klik op een pagina om een link op die pagina in te voegen."
  },
  click_to_embed_image_33107dd8: {
    message: "Klikken om de afbeelding in te sluiten"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Klikken om { imageName } in te sluiten"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Klik om een koppeling in te voegen in de editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Klik om een koppeling in dit item in te voegen"
  },
  close_flickr_form_b32e600a: {
    message: "Flickr-formulier sluiten"
  },
  collaborations_5c56c15f: {
    message: "Samenwerkingen"
  },
  copyright_holder_66ee111: {
    message: "Houder van auteursrecht:"
  },
  course_navigation_dd035109: {
    message: "Cursusnavigatie"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons-licentie:"
  },
  decorative_image_fde98579: {
    message: "Decoratieve afbeelding"
  },
  discussions_a5f96392: {
    message: "Discussies"
  },
  discussions_index_6c36ced: {
    message: "Discussieoverzicht"
  },
  embed_image_1080badc: {
    message: "Afbeelding insluiten"
  },
  enter_search_terms_e397b1f0: {
    message: "zoektermen invoeren"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Voer de alternatieve tekst voor deze afbeelding in"
  },
  file_upload_form_4aaad554: {
    message: "Formulier voor bestand uploaden"
  },
  files_c300e900: {
    message: "Bestanden"
  },
  files_index_af7c662b: {
    message: "Bestandsoverzicht"
  },
  folder_705fd2d7: {
    message: "Map"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Tekstkleur, er op drukken om een optie te selecteren"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Opmaak, er op drukken om een optie te selecteren"
  },
  grades_a61eba0a: {
    message: "Cijfers"
  },
  group_navigation_99f191a: {
    message: "Groepsnavigatie"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Ik heb toestemming gekregen om dit bestand te gebruiken."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Ik heb het auteursrecht"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Als je nu geen gebruiksrechten selecteert, wordt de publicatie van dit bestand ongedaan gemaakt nadat het is ge\xFCpload."
  },
  image_upload_form_7b74079a: {
    message: "Formulier voor afbeelding uploaden"
  },
  images_7ce26570: {
    message: "Afbeeldingen"
  },
  insert_equella_links_49a8dacd: {
    message: "Equella-koppelingen invoegen"
  },
  insert_link_6dc23cae: {
    message: "Koppeling invoegen"
  },
  insert_math_equation_57c6e767: {
    message: "Wiskundige vergelijking invoeren"
  },
  link_7262adec: {
    message: "Koppeling"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Koppelen aan een nieuwe pagina"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Koppeling naar andere inhoud in de cursus."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Link naar andere inhoud in de groep."
  },
  link_to_url_52dd935c: {
    message: "Koppeling naar URL"
  },
  links_14b70841: {
    message: "Koppelingen"
  },
  load_more_results_460f49a9: {
    message: "Meer resultaten laden"
  },
  loading_25990131: {
    message: "Bezig met laden..."
  },
  loading_failed_b3524381: {
    message: "Laden mislukt..."
  },
  loading_folders_8d4d5d5a: {
    message: "Mappen laden..."
  },
  modules_c4325335: {
    message: "Modules"
  },
  no_results_940393cf: {
    message: "Geen resultaten."
  },
  pages_e5414c2c: {
    message: "Pagina''s"
  },
  people_b4ebb13c: {
    message: "Personen"
  },
  quizzes_7e598f57: {
    message: "Toetsen"
  },
  record_upload_media_5fdce166: {
    message: "Media opnemen/uploaden"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Rich Text Area. Druk ALT+F8 voor hulp"
  },
  search_280d00bd: {
    message: "Zoeken"
  },
  search_flickr_6884b518: {
    message: "Zoeken in Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Selecteer een bestand"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Selecteer een map om je bestand te uploaden"
  },
  syllabus_f191f65b: {
    message: "Syllabus"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Tekstkleur, er op drukken om een optie te selecteren"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Het materiaal bevindt zich in het openbaar domein"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Het materiaal is onder Creative Commons gelicentieerd"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Het materiaal is onderworpen aan de uitzondering van redelijk gebruik"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Met deze upload wordt het quotum voor bestandsopslag overschreden. Neem contact op met je systeembeheerder."
  },
  upload_8b403d05: {
    message: "Uploaden"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Een nieuw bestand uploaden"
  },
  upload_a_new_image_890df275: {
    message: "Een nieuwe afbeelding uploaden"
  },
  usage_right_ff96f3e2: {
    message: "Gebruiksrecht:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Hoe wil je de nieuwe pagina noemen?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki Home"
  }
};

_formatMessage.default.addLocale({
  nl: locale
});